export const TipsDistributionRoutesJS = {
    "/tips-distribution": {
        "name": "appLayout.harriSH.tips-distribution",
        "headTags": [],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("./tips-distribution.module.js");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("../tips-management/tips-management.module.js");
                }
            },
        ]
    },
};